import React from "react"
import { Row, Col } from 'antd';
import FormContatti from "./FormContatti";

export const SectionContatti = ({ title, description, objectForm }) => {
    return (
        <div className="container-section-info">
            <Row align="middle" justify="center" type="flex" className="container-item">
                <Col xs={24} sm={24} md={12} lg={8} xl={8} className="container-info-web">
                    <h1 className="color-white">{title}</h1>
                    <h2 className="color-white">{description}</h2>
                    <FormContatti objectForm={objectForm} />
                </Col>
            </Row>
        </div>
    )
}
